import React from "react";
import { useNewsletterContext } from "scmp-sdk/components/newsletter/newsletter-widget/contexts";

import { Description } from "./styles";

export const DescriptionDisplay: React.FunctionComponent = () => {
  const { newsletterItemForDisplay } = useNewsletterContext();

  return <Description>{newsletterItemForDisplay?.homepageDescription?.text}</Description>;
};

DescriptionDisplay.displayName = "DescriptionDisplay";
